// AddDeductTax-specific utils.
// Shared constants (TABLE_STYLES, filterAccounts, renderCoaOption) live in src/Components/shared/tableUtils.js

export { EXCLUDED_ACCOUNT_TYPES, filterAccounts, TABLE_STYLES, renderCoaOption, formatAmountBlur } from "../shared/tableUtils";


export const ADD_DED_OPTIONS = [
    { label: "--Select--", value: "" },
    { label: "Addition", value: 9 },
    { label: "Deduction", value: 10 }
];

export const TAX_OPTIONS = [
    { label: "--Select--", value: "" },
    { label: "Employee Tax", value: 11 },
    { label: "Employer Tax", value: 12 }
];

export const MAPPED_TO_BASE = [
    { ItemID: "", PayrollItemName: "--Select--" },
    { ItemID: "ADD_NEW", PayrollItemName: "Add New" }
];

export const renderMappedToOption = (props, option, state) => {
    const { key, ...restProps } = props;
    const uniqueKey = `${option?.ItemID ?? option?.value ?? key ?? "item"}-${state?.index ?? ""}`;
    const label = option.PayrollItemName || option.ItemName || "";
    if (option.ItemID === "ADD_NEW") {
        return (
            <li key={uniqueKey} {...restProps} title={label} style={{ color: "#d32f2f", fontWeight: 500 }}>
                <span title={label}>{label}</span>
            </li>
        );
    }
    return (
        <li key={uniqueKey} {...restProps} title={label}>
            <span title={label} style={{ fontSize: 11, flex: 1, whiteSpace: "nowrap" }}>{label}</span>
        </li>
    );
};
